"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "tutorialModal";
  var componentName = "tutorialModal";

  var bindings = {};

  var templateUrl = "app/pages/tutorialModal/tutorialModal.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $rootScope, $window, $timeout, $sce, CustomersService) {
      _classCallCheck(this, Controller);

      console.log(moduleName + "/" + componentName);

      this.$scope = $scope;
      this.$rootScope = $rootScope;
      this.$window = $window;
      this.$timeout = $timeout;
      this.$sce = $sce;
      this.CustomersService = CustomersService;
    }

    _createClass(Controller, [{
      key: "close",
      value: function close() {
        console.log("$scope", this.$scope);

        if (this.$scope.$parent) {
          this.$scope.$parent.$dismiss();
        }
      }
    }, {
      key: "$onInit",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var user, customer;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  user = this.$rootScope.$user;
                  _context.next = 3;
                  return this.CustomersService.findById({
                    _id: this.$rootScope.$selectedCustomerId.replace("$", "")
                  });

                case 3:
                  customer = _context.sent;


                  this.withApp = customer.infoUseApp === "Appli" || customer.infoUseApp === "DRM + Appli";
                  this.withEad = customer.eadPartner && customer.eadPartner !== "none";

                  this.isSuper = ["super-admin", "super-operator"].indexOf(user.role) > -1 ? true : false;

                  this.isAdmin = ["super-admin", "super-operator", "user-admin"].indexOf(user.role) > -1 ? true : false;

                  this.writeResource = this.isAdmin || user.rights && user.rights.resource && user.rights.resource.write && user.rights.resource.write === true;
                  this.writeDamage = this.isAdmin || user.rights && user.rights.damage && user.rights.damage.write && user.rights.damage.write === true;
                  this.writeDepa = this.isAdmin || user.rights && user.rights.depa && user.rights.depa.write && user.rights.depa.write === true;
                  this.writeCourse = this.isAdmin || user.rights && user.rights.course && user.rights.course.write && user.rights.course.write === true;

                  this.$scope.$applyAsync();

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function $onInit() {
          return _ref.apply(this, arguments);
        }

        return $onInit;
      }()
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    //transclude: true,
    controller: Controller
  });
})();